import React, { Component, PropTypes } from 'react';
import { RouteTransition, presets } from 'react-router-transition';
import bowser from 'bowser';

import ErrorModalContainer from '../containers/ErrorModalContainer';

import { supportsVideoAutoPlay } from '../util';

import './Loading.css';

export default class Loading extends Component {
    render() {
        const autoplayEnabled = supportsVideoAutoPlay();

        const videoJsx = autoplayEnabled ?
            <div className="inner">
                <video width="320" height="320" muted autoPlay playsInline>
                    <source src="images/splash@2x.mp4" type="video/mp4" />
                </video>
            </div> : null;

        const fallbackCssClass = autoplayEnabled ? null : `fallback`;

        return (
            <div className={`loading-screen ${fallbackCssClass}`}>
                <ErrorModalContainer />
                {videoJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Loading.jsx